import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  SEND_MESSAGE_TO_LEAD,
  GET_ENQUIRY_MESSAGES,
  get_headers,
  get_project_id,
  get_token
} from '@/utils/constants/constants.js';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import LiveChat from '@/views/probaworkflows_base/management/leads_management/live_chat/LiveChat.vue';
import ShareFormsWithLead from '@/views/probaworkflows_base/management/leads_management/share_forms_with_lead/ShareFormsWithLead.vue';

export default {
  name: 'LeadResponses',
  components:{
    AICampusFooter,
    LiveChat,
    ShareFormsWithLead,
  },
  mixins: [alert_mixin],
  data: () => ({ 
    token: get_token(),
    headers: get_headers(),
    project_id: get_project_id(),
    enquiry_form_id: sessionStorage.getItem('enquiry_form_id'),
    tabs: ['Lead Responses', 'Chat With Lead' , 'Share Lead Questionnaire'],
    active_tab: 'Lead Responses',
    show_lead_responses: true, // You can remove if not used elsewhere
    show_live_chat: false,     // Same here
    is_loading: false,
    lead_responses: [],
    lead_messages: [],
    admin_message: '',
    pollInterval: null,
    user_scrolled_up: false,
    selected_file: null,
    viewer_open: false,
    viewer_url:  '',
    viewer_name: '', 
  }),
  created() {

    this.fetch_lead_messages();
  },
  mounted(){
    this.enquiry_form_id = sessionStorage.getItem('enquiry_form_id');
    this.pollInterval = setInterval(this.fetch_lead_messages, 1000);
    this.$refs.scrollContainer?.addEventListener('scroll', this.handle_user_scroll);

  },
  beforeUnmount() {
    clearInterval(this.pollInterval);
    this.$refs.scrollContainer?.removeEventListener('scroll', this.handle_user_scroll);
  },
  methods: {
    set_active_tab(tab) {
      this.active_tab = tab;
    },

    is_image(name) {
      return /\.(png|jpe?g|gif|webp|bmp)$/i.test(name || '');
    },

    open_attachment(msg) {
      this.viewer_url  = msg.attachment_url;
      this.viewer_name = msg.attachment_name;
      this.viewer_open = true;
    },

    close_viewer() {
      this.viewer_open = false;
      this.viewer_url  = '';
      this.viewer_name = '';
    },

    handle_file_change(e) {
    this.selected_file = e.target.files[0] || null;
    },
    clear_file() {
      this.selected_file = null;
      this.$refs.file_input.value = "";
    },
    
    fetch_lead_messages() {
      const lead_id = this.$route.query.lead_id;
      if (!lead_id) {
        this.show_error('No lead ID provided');
        return;
      }
    
      axios.get(GET_ENQUIRY_MESSAGES, {
        params: { lead_id },
        headers: this.headers
      })
      .then(response => {
        if (response.data.status === 'success') {
          this.lead_messages = response.data.data;
          this.scrollToBottom();
        } else {
          this.show_error('Could not load messages');
        }
      })
      .catch(err => {
        this.show_error('Message load failed', err);
      });
    },
    
  
    send_admin_message() {
      if (!this.admin_message.trim() && !this.selected_file) return;
      
      const form_data = new FormData();
      form_data.append('lead_id', this.$route.query.lead_id);
      if (this.admin_message.trim()) {
        form_data.append('message', this.admin_message.trim());
      }
      if (this.selected_file) {
        form_data.append('attachment', this.selected_file);
      }
  
      axios.post(SEND_MESSAGE_TO_LEAD, form_data, {
        headers: { ...this.headers,
          'Content-Type': 'multipart/form-data',
         },
      })
      .then(res => {
        if (res.data.status === 'success') {
          this.admin_message = '';
          this.clear_file();
          this.fetch_lead_messages();
        } else {
          this.show_error('Failed to send message');
        }
      })
      .catch(() => {
        this.show_error('Message failed to send');
      });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (container && !this.user_scrolled_up) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    handle_user_scroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;
      const atBottom =
        container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
      this.user_scrolled_up = !atBottom;
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString();
    }
  }
};